/* ============================================
   Mobile nav
   ============================================ */

(function () {
  const burgerBtn = document.querySelector('.burger-btn');
  const mobileNav = document.getElementById('mobile-nav');
  const overlay   = document.querySelector('.mobile-nav__overlay');
  const closeBtn  = document.querySelector('.mobile-nav__close');

  if (!burgerBtn || !mobileNav) return;

  function openMenu() {
    mobileNav.classList.add('is-open');
    overlay.classList.add('is-open');
    burgerBtn.setAttribute('aria-expanded', 'true');
    mobileNav.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
  }

  function closeMenu() {
    mobileNav.classList.remove('is-open');
    overlay.classList.remove('is-open');
    burgerBtn.setAttribute('aria-expanded', 'false');
    mobileNav.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    burgerBtn.focus();
  }

  burgerBtn.addEventListener('click', openMenu);
  closeBtn.addEventListener('click', closeMenu);
  overlay.addEventListener('click', closeMenu);

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) closeMenu();
  });
})();

/* ============================================
   Hero carousel
   ============================================ */

(function () {
  const carousel = document.querySelector('.hero-carousel');
  if (!carousel) return;

  const slides  = Array.from(carousel.querySelectorAll('.hero-carousel__slide'));
  const dots    = Array.from(carousel.querySelectorAll('.hero-carousel__dot'));
  const prevBtn = carousel.querySelector('.hero-carousel__arrow--prev');
  const nextBtn = carousel.querySelector('.hero-carousel__arrow--next');

  if (slides.length < 2) return;

  const autoplay = carousel.dataset.autoplay === 'true';
  const speed    = parseInt(carousel.dataset.speed, 10) || 5000;
  let current    = 0;
  let timer      = null;

  function goTo(index) {
    slides[current].classList.remove('is-active');
    slides[current].setAttribute('aria-hidden', 'true');
    dots[current]?.classList.remove('is-active');
    dots[current]?.setAttribute('aria-selected', 'false');

    current = (index + slides.length) % slides.length;

    slides[current].classList.add('is-active');
    slides[current].setAttribute('aria-hidden', 'false');
    dots[current]?.classList.add('is-active');
    dots[current]?.setAttribute('aria-selected', 'true');
  }

  function startTimer() {
    if (!autoplay) return;
    timer = setInterval(() => goTo(current + 1), speed);
  }

  function resetTimer() {
    clearInterval(timer);
    startTimer();
  }

  prevBtn?.addEventListener('click', () => { goTo(current - 1); resetTimer(); });
  nextBtn?.addEventListener('click', () => { goTo(current + 1); resetTimer(); });

  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => { goTo(i); resetTimer(); });
  });

  carousel.addEventListener('mouseenter', () => clearInterval(timer));
  carousel.addEventListener('mouseleave', startTimer);

  /* Swipe support */
  let touchStartX = 0;
  carousel.addEventListener('touchstart', e => { touchStartX = e.changedTouches[0].screenX; }, { passive: true });
  carousel.addEventListener('touchend', e => {
    const delta = e.changedTouches[0].screenX - touchStartX;
    if (Math.abs(delta) < 40) return;
    goTo(delta < 0 ? current + 1 : current - 1);
    resetTimer();
  }, { passive: true });

  startTimer();
})();

/* ============================================
   Cart count sync
   ============================================ */

function updateCartCount(count) {
  document.querySelectorAll('[data-cart-count]').forEach(el => {
    el.textContent = count;
    el.style.display = count > 0 ? 'flex' : 'none';
  });
}

/* ============================================
   Product gallery thumbnails
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const featuredImg = document.getElementById('FeaturedMedia');

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');

      if (featuredImg) {
        const src = thumb.querySelector('img')?.src;
        if (src) featuredImg.src = src;
      }
    });
  });

  /* ============================================
     Variant selector — update price and button state
     ============================================ */

  const productJSON = document.getElementById('ProductJSON-{{ section.id }}');
  const variantSelect = document.querySelector('[data-variant-select]');
  const optionSelects = document.querySelectorAll('[data-option-position]');
  const priceEl = document.querySelector('[data-product-price]');
  const addToCartBtn = document.querySelector('[data-add-to-cart]');

  if (productJSON && variantSelect && optionSelects.length) {
    const product = JSON.parse(productJSON.textContent);

    function getSelectedVariant() {
      const selectedOptions = Array.from(optionSelects).map(s => s.value);
      return product.variants.find(v =>
        v.options.every((opt, i) => opt === selectedOptions[i])
      );
    }

    function updateVariant() {
      const variant = getSelectedVariant();
      if (!variant) return;

      variantSelect.value = variant.id;

      if (priceEl) {
        const money = amount => {
          return new Intl.NumberFormat(document.documentElement.lang, {
            style: 'currency',
            currency: Shopify?.currency?.active || 'USD',
            minimumFractionDigits: 2
          }).format(amount / 100);
        };

        let html = `<span>${money(variant.price)}</span>`;
        if (variant.compare_at_price > variant.price) {
          html += `<s class="product-price--compare">${money(variant.compare_at_price)}</s>`;
        }
        priceEl.innerHTML = html;
      }

      if (addToCartBtn) {
        addToCartBtn.disabled = !variant.available;
        addToCartBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
    }

    optionSelects.forEach(sel => sel.addEventListener('change', updateVariant));
  }
});

/* ============================================
   Cart form — async add-to-cart
   ============================================ */

document.addEventListener('submit', async event => {
  const form = event.target;
  if (!form.matches('[data-product-form]')) return;
  event.preventDefault();

  const btn = form.querySelector('[data-add-to-cart]');
  const originalText = btn?.textContent;

  if (btn) {
    btn.disabled = true;
    btn.textContent = 'Adding...';
  }

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: form.querySelector('[data-variant-select], [name="id"]').value,
        quantity: parseInt(form.querySelector('[name="quantity"]')?.value || 1, 10)
      })
    });

    if (!res.ok) throw new Error('Cart error');

    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();
    updateCartCount(cart.item_count);
  } catch (err) {
    console.error(err);
  } finally {
    if (btn) {
      btn.disabled = false;
      btn.textContent = originalText;
    }
  }
});
